<script>
    import Icon from "fa-svelte";
    import {
        faCloudDownloadAlt,
        faTimes,
    } from "@fortawesome/free-solid-svg-icons";
    import { getAssetURL } from "../../common/assets";
    import { deleteAsset, fetchAssets } from "../../stores/assets";
    import { handleAsync } from "../../common/safe_promise";
    import { createEventDispatcher } from "svelte";

    export let asset;
    export let deletable = true;

    const dispatch = createEventDispatcher();

    const handleDelete = handleAsync(async () => {
        await deleteAsset(asset.fullPath);
        await fetchAssets();
    });

    const handleRemove = () => {
        dispatch("remove");
    };
</script>

<style>
    .rounded-xl {
        max-width: 15em;
    }
</style>

<div class="rounded-xl elevation-2 overflow-hidden flex flex-col">
    {#if asset.metadata && asset.metadata.contentType}
        {#if asset.metadata.contentType.startsWith('image')}
            <img
                src={getAssetURL(asset.fullPath)}
                class="object-cover w-full"
                alt="Asset" />
        {/if}
    {/if}

    <div class="p-4 flex items-center">
        <span class="text-center flex-grow">{asset.name}</span>
        <a
            class="flex justify-center items-center"
            href={getAssetURL(asset.fullPath)}
            target="blank">
            <button class="bg-white text-gray-700 focus:outline-none">
                <Icon icon={faCloudDownloadAlt} />
            </button>
        </a>
        <button
            class="bg-white text-red-700 focus:outline-none"
            on:click|stopPropagation={deletable ? handleDelete : handleRemove}>
            <Icon icon={faTimes} />
        </button>
    </div>
</div>
